import React from 'react'
import Navbar from './components/Navbar'
import HeroSima from './components/HeroSima'
import SimaEventInfo from './components/SimaEventInfo'
import WhyPuntaCana from './components/WhyPuntaCana'
import AboutBavarianSima from './components/AboutBavarianSima'
import ProjectsSima from './components/ProjectsSima'
import BenefitsSima from './components/BenefitsSima'
import FAQSectionSima from './components/FAQSectionSima'
import ContactClosingSima from './components/ContactClosingSima'
import Footer from './components/Footer'
import StickyMobileCTA from './components/StickyMobileCTA'

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-background text-text-primary selection:bg-accent/20">
      <Navbar />
      <main id="main-content">
        <HeroSima />
        <SimaEventInfo />
        <WhyPuntaCana />
        <AboutBavarianSima />
        <ProjectsSima />
        <BenefitsSima />
        <FAQSectionSima />
        <ContactClosingSima />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  )
}

export default App
